<template>
  <div>
    <l-tables :tableConfig="tableConfig"  :searchParams='searchData' :noCreatText="$t('admin.trainingRoom.noCreatText')" :ImgSrc='nullImg' @tableChange="handleTableHeaderChange">
      <template slot="searchConditions">
        <a-input v-model="keyword" @change="search" maxlength="30" :placeholder="$t('admin.trainingRoom.searchPlaceholder')">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
        </a-input>
      </template>
      <template #name="{ record }">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ record.name }}</span>
          </template>
          <span>{{ record.name }}</span>
        </a-tooltip>
      </template>
      <template #place="{ record }">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ record.place }}</span>
          </template>
          <span>{{ record.place }}</span>
        </a-tooltip>
      </template>
      <template #area="{ record }">
        {{record.area}}㎡
      </template>
      <template #statusName="{ record }">
        <span :style="{color:record.statusName=='开启'?'#2DB58B':'#F06321'}">{{record.statusName}}</span>
      </template>
      <template #constructionYear="{ record }">
       {{record.constructionYear==''?'--':record.constructionYear}}
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('admin.trainingRoom.createRoom') }}</a-button>
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('admin.trainingRoom.createRoom') }}</a-button>
      </template>

    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'

export default {
  components: {
    LTables
  },
  data() {
    return {
      noCreatText: this.$t('admin.trainingRoom.noCreatText'),
      nullImg: require('@/assets/img/trainingRoomlistNull.png'),
      keyword: undefined,
      searchData: {
        name: ''
      },
      tableConfig: {
        tableName: this.$t('admin.trainingRoom.title'),
        tableColumns: [
          {
            title: this.$t('admin.trainingRoom.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80,
          },
          {
            title: this.$t('admin.trainingRoom.name'),
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            ellipsis: true,
            scopedSlots: { customRender: 'name' }
          },
          {
            title: this.$t('admin.trainingRoom.place'),
            dataIndex: 'place',
            key: 'place',
            align: 'center',
            ellipsis: true,
            scopedSlots: { customRender: 'place' }
          },
          {
            title: this.$t('admin.trainingRoom.area'),
            dataIndex: 'area',
            key: 'area',
            align: 'center',
            ellipsis: true,
            scopedSlots: { customRender: 'area' }
          },
          {
            title: this.$t('admin.trainingRoom.constructionYear'),
            dataIndex: 'constructionYear',
            key: 'constructionYear',
            align: 'center',
            scopedSlots: { customRender: 'constructionYear' }
          },
          {
            title: this.$t('admin.trainingRoom.number'),
            dataIndex: 'number',
            key: 'number',
            align: 'center'
          },
          {
            title: this.$t('admin.trainingRoom.status'),
            dataIndex: 'statusName',
            key: 'statusName',
            align: 'center',
            width: 80,
            scopedSlots: { customRender: 'statusName' },
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.trainingRoom.statusOpen'), value: '开启' },
              { text: this.$t('admin.trainingRoom.statusClose'), value: '关闭' }
            ],
          },
          {
            title: this.$t('admin.trainingRoom.createdAt'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center',
            sortDirections: ["descend", "ascend", "descend"],
            sorter: true,
          },
          {
            title: this.$t('admin.trainingRoom.operations'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('admin.trainingRoom.deleteConfirm.title'),
          content: this.$t('admin.trainingRoom.deleteConfirm.content')
        },
        tablePort: {
          list: '/training_room/list',
          del: '/training_room/delete'
        },
        tableEditRouteNName: 'trainingRoomAdd'
      }
    }
  },
  methods: {
    search() {
      this.searchData.name = this.keyword
    },
    create() {
      this.$router.push({
        name: 'trainingRoomAdd'
      })
    },
    handleTableHeaderChange([filters, getList, sorter]) {
      const filterKey = [['statusName', 'status'], ['recommendName', 'isRecommend']]
      let timeSort = {}
      if (sorter.order === 'ascend') {
        timeSort.time_sort = 2
      } else if (sorter.order === 'descend') {
        timeSort.time_sort = 1
      }
      const result = { ...timeSort }
      filterKey.forEach(item => {
        if (filters[item[0]]) {
          result[item[1]] = filters[item[0]].map(f => {
            if (f === '开启' || f === '未推荐') {
              return 1
            }
            return 2
          })
          result[item[1]] = result[item[1]].length > 1 ? '' : result[item[1]][0]
        }
      })
      getList({ condition: result })
    },
  }
}
</script>

<style lang="less" scoped>

</style>
